
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/feeds/100sangjo",
      function () {
        return require("private-next-pages/content/feeds/100sangjo.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/feeds/100sangjo"])
      });
    }
  